module.exports = __webpack_public_path__ + "static/img/22.afb646a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/22.jpg
// module id = yi+K
// module chunks = 1